import { Modal, Paragraph } from '@packages/utils';
import { useTheme } from 'styled-components';
import { Image } from 'components/Base/Image';
import { TGetLightBoxUI } from 'data/types/lightBox.types';
import { SLightBoxCardWrapper } from './ELCLightboxModal.styles';

type TELCLightboxModalProps = {
  open: boolean;
  onClose: () => void;
  lightboxData: TGetLightBoxUI;
};

const ELCLightboxModal = ({
  open,
  onClose,
  lightboxData,
}: TELCLightboxModalProps) => {
  const theme = useTheme();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={600}
      centered
      maskClosable
      destroyOnClose
    >
      <SLightBoxCardWrapper>
        <Image
          src={lightboxData.picture}
          alt=""
          className="mb-4"
          aria-hidden="true"
          style={{ textAlign: 'center' }}
        />
        <Paragraph
          className="text-center"
          fontWeight={theme.fontWeightMedium}
          color={theme.colorPinkActive}
          style={{ textAlign: 'center' }}
        >
          {lightboxData.firstSection}
        </Paragraph>
        <Paragraph className="text-center my-4" style={{ textAlign: 'center' }}>
          {lightboxData.secondSection}
        </Paragraph>
      </SLightBoxCardWrapper>
    </Modal>
  );
};

export default ELCLightboxModal;
